module.exports = __webpack_public_path__ + "static/media/logoC.94e32e56.png";